import { createStyles, makeStyles } from '@material-ui/core';

import styles from 'components/TableView/styles';

export const useStyles = makeStyles((theme) => createStyles(styles(theme)));
